import React from 'react'

import AbsolutePageTemplate from '../../../components/templates/AbsolutePageTemplate'
import PageContent from './PageContent'
import PageHeader from './_shared/PageHeader'
import ServiceOrderLoader from './_load/ServiceOrderLoader'
import ParentServiceOrderLoader from './_load/ParentServiceOrderLoader'
import PlacesLoader from './_load/PlaceLoader'

const TemplateInternoPdfPage = ({ id, templateId }) => {
  return (
    <AbsolutePageTemplate>
      <ServiceOrderLoader id={id}>
        <ParentServiceOrderLoader>
          <PlacesLoader>
            <PageHeader templateId={parseInt(templateId)} />
            <PageContent templateId={parseInt(templateId)} />
          </PlacesLoader>
        </ParentServiceOrderLoader>
      </ServiceOrderLoader>
    </AbsolutePageTemplate>
  )
}

export default TemplateInternoPdfPage
